import { render } from "./index.vue?vue&type=template&id=cedd1bd2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cedd1bd2&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedd1bd2"],['__file',"src/components/RadioFields/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cedd1bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cedd1bd2', __exports__)) {
    console.log('reload')
    api.reload('cedd1bd2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=cedd1bd2&scoped=true", () => {
    console.log('re-render')
    api.rerender('cedd1bd2', render)
  })

}


export default __exports__